import { useMobileOS } from '@beef/react';
export var OS;
(function (OS) {
  OS["Android"] = "android";
  OS["IOS"] = "ios";
})(OS || (OS = {}));
export var IOS = function IOS(_ref) {
  var children = _ref.children;
  var os = useMobileOS();
  return os === OS.IOS || !os ? children : null;
};
export var Android = function Android(_ref2) {
  var children = _ref2.children;
  var os = useMobileOS();
  return os === OS.Android || !os ? children : null;
};
export var Desktop = function Desktop(_ref3) {
  var children = _ref3.children;
  var os = useMobileOS();
  return !os ? children : null;
};